import React, { Fragment } from 'react';
import { StateModel } from '../../../redux/store';
import { connect } from 'react-redux';
import GridCellWrapper from '../../../components/grid-cell-wrapper/GridCellWrapper';
import { ConfigModel } from '../../../models/ConfigModel';
import SliderCheckbox from '../../../components/slidercheckbox/SliderCheckbox';
import Button from '../../../components/button/Button';
import {
  saveConfig,
  setConfigModel,
  setConfigParamField,
  updateConfigParam,
} from '../../../redux/actions/coco';
import { toSelectOptions } from '../../../components/select/SelectModel';
import Select from '../../../components/select/Select';
import { nameof } from '../../../utils/objectUtils';
import { setNotification } from '../../../utils/notificationUtils';
import { ConfigParam } from '../../../api';

import {
  BEXITY,
  changeConfig,
  CLIENT_KUNDEN,
  GERSTLAUER,
  HAALBOOM,
  MMT,
  PHL,
  SERVICES,
  SIEVERS,
  TABLE_CONFIGS,
  WDS,
} from './client-config-assembler';

interface CocoProps {
  config: ConfigModel;
  updateConfigParam: (cpa: ConfigParam[]) => void;
  setConfigParamField: (value: string | boolean, fieldName: string) => void;
  setConfigModel: (model: ConfigModel) => void;

  saveConfig(): void;
}

const ComfortableConfigurator = (props: CocoProps) => {
  const saveAenderungen = () => {
    if (props.config.isTauschgeraete && props.config.isZusaetzlicheLademittel) {
      setNotification(
        'Tauschgeräte und zusätzliche Lademittel dürfen nicht beide gewählt sein.',
        []
      );
    } else {
      props.saveConfig();
    }
  };

  const viewConfig = () => {
    return (
      <Fragment>
        <div className={'config'}>
          <label>Mautrechner </label>
          <SliderCheckbox
            value={props.config.isMautrechner ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isMautrechner,
                nameof<ConfigModel>('isMautrechner')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'Mautrechner aktiv'}
            disabled={false}
          />
          <p>
            Wird auf der Login-Seite der Mautrechner angezeigt? <br />
          </p>
          <p> Kunde: nur für Bexity</p>
        </div>
        <div className={'config'}>
          <label>Registrierung </label>
          <SliderCheckbox
            value={props.config.isRegistrierung ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isRegistrierung,
                nameof<ConfigModel>('isRegistrierung')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'Registrierung aktiv'}
            disabled={false}
          />
          <p>
            Ist eine Registrierung von Kunden im Don möglich, <br />
            (de)aktiviert auf Login-Seite der Knopf &quot;Registrierung&quot;
          </p>
          <p> Kunde: derzeit nur für Bexity</p>
        </div>
        <div className={'config'}>
          <label>Preisermittlung </label>
          <SliderCheckbox
            value={props.config.isPreisermittlung ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isPreisermittlung,
                nameof<ConfigModel>('isPreisermittlung')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'Preisermittlung aktiv'}
            disabled={false}
          />
          <p>arbeitet der Kunde mit Preisermittlung (vorab-Kalkulation)?</p>
          <p>Kunde: Bexity aus, Kunden, die nicht erfassen, aus, sonst an</p>
        </div>
        <div className={'config'}>
          <label>CustomstyleButtons</label>
          <SliderCheckbox
            value={props.config.isCustomstylebuttons ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isCustomstylebuttons,
                nameof<ConfigModel>('isCustomstylebuttons')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'Customstylebuttons sichtbar'}
            disabled={false}
          />
          <p>
            Ist eine lokale Einstellung für WDS, um zwischen den Stylesheets zu
            wechseln
          </p>
          <p>Kunde: nicht bei Kunden anwenden</p>
        </div>
        <div className={'config'}>
          <label>BexPremium</label>
          <SliderCheckbox
            value={props.config.isBexPremium ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isBexPremium,
                nameof<ConfigModel>('isBexPremium')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'BexPremium sichtbar'}
            disabled={false}
          />
          <p>
            Wenn &quot;aktiv&quot; wird Bex-Premium-Import im Adminbereich
            angezeigt.
            <br />
            Damit kann der Kunde eine csv-Liste für die Premium-Dienste einlesen{' '}
          </p>
          <p>Kunde: Bexity</p>
        </div>
        <div className={'config'}>
          <label>Uhrzeitfelder ausblenden</label>
          <SliderCheckbox
            value={props.config.isDisableUhrzeitfelder ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isDisableUhrzeitfelder,
                nameof<ConfigModel>('isDisableUhrzeitfelder')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'Uhrzeitfelder ausblenden'}
            disabled={false}
          />
          <p>
            Werden bei der Auftragserfassung die Uhrzeitfelder angezeigt bei
            Datum Abholung und Datum Zustellung
          </p>
          <p>Kunde: Bexity = aus, im Standard sind sie sichtbar</p>
        </div>
        <div className={'config'}>
          <label>Tauschgeräte</label>
          <SliderCheckbox
            value={props.config.isTauschgeraete ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isTauschgeraete,
                nameof<ConfigModel>('isTauschgeraete')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'Tauschgeräte sichtbar'}
            disabled={false}
          />
          <p>
            sollen die Tauschgeräte in der Auftragserfassung im Bereich
            &quot;Allgemein&quot; dargestellt werden. Steht in direkter
            Konkurrenz zu zusaetzliche Lademittel. Es darf nur eine der beiden
            &quot;aktiv&quot; sein.
          </p>
          <p>Kunde: Bexity = aktiv, sonst aus</p>
        </div>
        <div className={'config'}>
          <label>zusätzliche Lademittel</label>
          <SliderCheckbox
            value={props.config.isZusaetzlicheLademittel ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isZusaetzlicheLademittel,
                nameof<ConfigModel>('isZusaetzlicheLademittel')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'zusätzliche Lademittel sichtbar'}
            disabled={false}
          />
          <p>
            sollen die zusätzliche Lademittel in der Auftragserfassung im
            Bereich &quot;Allgemein&quot; dargestellt werden. Steht in direkter
            Konkurrenz zu Tauschgeräte. Es darf nur eine der beiden
            &quot;aktiv&quot; sein.
          </p>
          <p>Kunde: Bexity = aus, sonst aktiv</p>
        </div>
        <div className={'config'}>
          <label>Länge in Auftragpos Pflicht</label>
          <SliderCheckbox
            value={props.config.isLaengePflichtfeld ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isLaengePflichtfeld,
                nameof<ConfigModel>('isLaengePflichtfeld')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'Länge Pflichtfeld'}
            disabled={false}
          />
          <p>
            bestimmt, ob das Feld &quot;Länge&quot; in der Auftragsposition ein
            Pflichtfeld ist
          </p>
          <p>Kunde: Bexity = aktiv</p>
        </div>
        <div className={'config'}>
          <label>Breite in Auftragpos Pflicht</label>
          <SliderCheckbox
            value={props.config.isBreitePflichtfeld ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isBreitePflichtfeld,
                nameof<ConfigModel>('isBreitePflichtfeld')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'Breite Pflichtfeld'}
            disabled={false}
          />
          <p>
            bestimmt, ob das Feld &quot;Breite&quot; in der Auftragsposition ein
            Pflichtfeld ist
          </p>
          <p>Kunde: Bexity = aktiv</p>
        </div>
        <div className={'config'}>
          <label>Höhe in Auftragpos Pflicht</label>
          <SliderCheckbox
            value={props.config.isHoehePflichtfeld ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isHoehePflichtfeld,
                nameof<ConfigModel>('isHoehePflichtfeld')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'Höhe Pflichtfeld'}
            disabled={false}
          />
          <p>
            bestimmt, ob das Feld &quot;Höhe&quot; in der Auftragsposition ein
            Pflichtfeld ist
          </p>
          <p>Kunde: Bexity = aktiv</p>
        </div>
        {/*//Verkehrsart*/}
        <div className={'config'}>
          <label>Verkehrsart Pflicht</label>
          <SliderCheckbox
            value={props.config.isVerkehrsartPflichtfeld ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isVerkehrsartPflichtfeld,
                nameof<ConfigModel>('isVerkehrsartPflichtfeld')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'Verkehrsart Pflichtfeld'}
            disabled={false}
          />
          <p>
            bestimmt, ob das Feld &quot;Verkehrsart&quot; im Auftrag ein
            Pflichtfeld ist
          </p>
          <p>Kunde: Bexity = aktiv</p>
        </div>
        {/*//Verkehrsart ENDE*/}
        {/*//LademittelBerechnen*/}
        <div className={'config'}>
          <label>Lademeter automatisch berechnen</label>
          <SliderCheckbox
            value={props.config.isLademeterBerechnen ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isLademeterBerechnen,
                nameof<ConfigModel>('isLademeterBerechnen')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'Lademeter berechnen'}
            disabled={false}
          />
          <p>
            bestimmt, ob das Feld &quot;Lademeter&quot; in der Auftragsposition
            automatisch berechnet wird
          </p>
          <p>Kunde: PHL = inaktiv</p>
        </div>
        {/*//LademittelBerechnen ENDE*/}
        {/*//StellplätzeBerechnen*/}
        <div className={'config'}>
          <label>Stellplätze automatisch berechnen</label>
          <SliderCheckbox
            value={props.config.isStellplaetzeBerechnen ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isStellplaetzeBerechnen,
                nameof<ConfigModel>('isStellplaetzeBerechnen')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'Stellplätze berechnen'}
            disabled={false}
          />
          <p>
            bestimmt, ob das Feld &quot;Stellpl&auml;tze&quot; in der
            Auftragsposition automatisch berechnet wird
          </p>
          <p>Kunde: PHL = inaktiv</p>
        </div>
        {/*//StellplätzeBerechnen ENDE*/}
        {/*//Beladetaum vorbelegen*/}
        <div className={'config'}>
          <label>Abholung vorbelegen</label>
          <SliderCheckbox
            value={props.config.isBeladedatumVorbelegen ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isBeladedatumVorbelegen,
                nameof<ConfigModel>('isBeladedatumVorbelegen')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'Abholung vorbelegen'}
            disabled={false}
          />
          <p>
            bestimmt, ob das Feld &quot;Abholung&quot; im Auftrag vorbelegt wird
          </p>
          <p>Kunde: PHL = inaktiv</p>
        </div>
        {/*//Beladetaum vorbelegenENDE*/}
        {/*//Entladetaum vorbelegen*/}
        <div className={'config'}>
          <label>Zustellung vorbelegen</label>
          <SliderCheckbox
            value={props.config.isEntladedatumVorbelegen ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isEntladedatumVorbelegen,
                nameof<ConfigModel>('isEntladedatumVorbelegen')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'Zustellung vorbelegen'}
            disabled={false}
          />
          <p>
            bestimmt, ob das Feld &quot;Zustellung&quot; im Auftrag vorbelegt
            wird
          </p>
          <p>Kunde: PHL = inaktiv</p>
        </div>
        {/*//Entladetaum vorbelegenENDE*/}
        {/*//Abholdatum pflicht */}
        <div className={'config'}>
          <label>Abholung Pflicht</label>
          <SliderCheckbox
            value={props.config.isAbholDatumPflicht ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isAbholDatumPflicht,
                nameof<ConfigModel>('isAbholDatumPflicht')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'Abholung Pflichtfeld'}
            disabled={false}
          />
          <p>
            bestimmt, ob das Feld &quot;Abholung&quot; im Auftrag ein
            Pflichtfeld ist
          </p>
          <p>Kunde: BEXity aktiv, sonst aus</p>
        </div>
        {/*//Abholdatum pflicht ENDE*/}
        {/*//Zustelldatum pflicht */}
        <div className={'config'}>
          <label>Zustellung Pflicht</label>
          <SliderCheckbox
            value={props.config.isZustellDatumPflicht ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isZustellDatumPflicht,
                nameof<ConfigModel>('isZustellDatumPflicht')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'Zustellung Pflichtfeld'}
            disabled={false}
          />
          <p>
            bestimmt, ob das Feld &quot;Zustellung&quot; im Auftrag ein
            Pflichtfeld ist
          </p>
          <p>Kunde: BEXity aktiv, sonst aus</p>
        </div>
        {/*//Abholdatum pflicht ENDE*/}
        <div className={'config'}>
          <label>Track & Trace E-Mailadresse anzeigen</label>
          <SliderCheckbox
            value={props.config.isShowTTMailAdress ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isShowTTMailAdress,
                nameof<ConfigModel>('isShowTTMailAdress')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'Track & Trace E-Mailadresse anzeigen'}
            disabled={false}
          />
          <p>
            bestimmt, ob das Feld &quot;E-Mailadresse Track & Trace&quot; in der
            Adresserfassung angezeigt wird
          </p>
          <p>Kunde: Bexity = inaktiv</p>
        </div>
        <div className={'config'}>
          <label>darf ein neuer User sofort erfassen</label>
          <SliderCheckbox
            value={props.config.isUserCanEditImmediately ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isUserCanEditImmediately,
                nameof<ConfigModel>('isUserCanEditImmediately')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={'darf ein neuer Benutzer sofort editieren'}
            disabled={false}
          />
          <p>
            Wenn &quot;aktiv&quot;, darf ein neu angelegter Benutzer sofort
            Aufträge erfassen, sonst darf er nur schauen
          </p>
          <p>Kunde: Bexity = aktiv</p>
        </div>
        <div className={'config'}>
          <label>Auftragserfassung Service (intern. Sendungen)</label>
          <SliderCheckbox
            value={props.config.isServicesInternSendungen ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isServicesInternSendungen,
                nameof<ConfigModel>('isServicesInternSendungen')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>
            Legt fest, ob die Services für internationale Sendungen angezeigt
            werden oder nicht.
          </p>
          <p>Kunde: Bexity = aktiv, sonst aus</p>
        </div>
        {/*//---- #84175 ---*/}
        <div className={'config'}>
          <label>Auftragserfassung Empfänger Rechnung</label>
          <SliderCheckbox
            value={props.config.isShowEmpfRechnung ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isShowEmpfRechnung,
                nameof<ConfigModel>('isShowEmpfRechnung')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>
            Legt fest, ob in der Auftragserfassung beim Empfänger der Button
            Rechnung sichtbar ist
          </p>
          <p>Kunde: Bexity = aktiv, sonst aus</p>
        </div>
        {/*//---- #84175 END ---*/}
        {/*//---- #84203 neuer config_param ---*/}
        <div className={'config'}>
          <label>Auftragserfassung Allgemein Klassifizierung</label>
          <SliderCheckbox
            value={props.config.isShowKlassifizierung ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isShowKlassifizierung,
                nameof<ConfigModel>('isShowKlassifizierung')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>
            Legt fest, ob in der Auftragserfassung im Bereich Allgemein die
            Combobox Klassifizierung sichtbar ist
          </p>
          <p>Kunde: Bexity = aktiv, sonst aus</p>
        </div>
        {/*//---- #84203 END ---*/}
        {/*//---- #84339 neuer config_param ---*/}
        <div className={'config'}>
          <label>Auftragserfassung Editieren verbieten</label>
          <SliderCheckbox
            value={props.config.denyOrderEdit ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.denyOrderEdit,
                nameof<ConfigModel>('denyOrderEdit')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>
            Legt fest, ob in der Auftragserfassung das Bearbeiten/Kopieren
            unterbunden werden soll
          </p>
          <p>Kunde: MMT = aktiv, sonst aus</p>
        </div>
        {/*//---- #84339 END ---*/}
        {/*//---- #84596 neuer config_param ---*/}
        <div className={'config'}>
          <label>Auftragserfassung keine ADR-Verpackungen</label>
          <SliderCheckbox
            value={props.config.isNoADRVerpackungen ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isNoADRVerpackungen,
                nameof<ConfigModel>('isNoADRVerpackungen')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>
            Legt fest, ob in der Auftragserfassung ADR-Verpackungen in den
            Auftragpositionen angeboten werden.
          </p>
          <p>Kunde: Gerstlauer = aktiv, sonst aus</p>
        </div>
        <div className={'config'}>
          <label>Auftragserfassung keine ADR-Lademittel</label>
          <SliderCheckbox
            value={props.config.isNoADRLademittel ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isNoADRLademittel,
                nameof<ConfigModel>('isNoADRLademittel')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>
            Legt fest, ob in der Auftragserfassung ADR-Lademittel in den
            Auftragpositionen angeboten werden.
          </p>
          <p>Kunde: Gerstlauer = aktiv, sonst aus</p>
        </div>
        {/*//---- #84596 END ---*/}
        {/*//---- #84563 neuer config_param ---*/}
        <div className={'config'}>
          <label>Auftragserfassung Zustelldatum sperren</label>
          <SliderCheckbox
            value={props.config.isDenyZustelldatum ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isDenyZustelldatum,
                nameof<ConfigModel>('isDenyZustelldatum')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>
            Wenn gesetzt, wird das Feld Zustellung für Eingaben gesperrt. Bei
            einer bestimmten Terminart wird es zum Editieren freigegeben . Diese
            Terminart kann momentan nur durch manuelle Änderung der Tabelle
            Config_params gesetzt werden. Bei Aktivierung wird hier auf
            Entwicklung die Terminart 4 (Fixtermin) eingetragen.
          </p>
          <p>Kunde: Bexity = aktiv, sonst aus</p>
        </div>
        {/*//---- #84563END ---*/}

        {/*//---- #84769 neuer config_param ---*/}
        <div className={'config'}>
          <label>Auftragserfassung Absender sperren</label>
          <SliderCheckbox
            value={props.config.isAbsenderEditDeny ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isAbsenderEditDeny,
                nameof<ConfigModel>('isAbsenderEditDeny')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>
            Wenn gesetzt, wird die Absenderadresse gesperrt, kein editieren mehr
            möglich!
          </p>
          <p>Kunde: Gerstlauer = aktiv, sonst aus</p>
        </div>
        {/*//---- #84769END ---*/}
        {/*//---- #84769 neuer config_param ---*/}
        <div className={'config'}>
          <label>Auftragserfassung Neutralen Absender Anzeigen</label>
          <SliderCheckbox
            value={props.config.isShowAbsenderNeutral ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isShowAbsenderNeutral,
                nameof<ConfigModel>('isShowAbsenderNeutral')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>
            Wenn gesetzt, wird in der Auftragserfassung der Button Neutral
            angeboten. Dort kann dann der Neutrale Absender des Auftrages
            erfasst werden.
          </p>
          <p>Kunde: Gerstlauer = aktiv, sonst aus</p>
        </div>
        {/*//---- #84769END ---*/}

        <div className={'config'}>
          <label>Adresse-Telefonfeld nach Übertragung editierbar </label>
          <SliderCheckbox
            value={props.config.isAdresseTelefonEdit ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isAdresseTelefonEdit,
                nameof<ConfigModel>('isAdresseTelefonEdit')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>
            Legt fest, ob das Telefonfeld einer Adresse auch für übertragene
            Adressen editierbar geschaltet sein soll.
          </p>
          <p>Kunde: Bexity = aktiv, sonst aus</p>
        </div>
        <div className={'config'}>
          <label>Adresse-Kontaktfeld nach Übertragung editierbar </label>
          <SliderCheckbox
            value={props.config.isAdresseKontaktEdit ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isAdresseKontaktEdit,
                nameof<ConfigModel>('isAdresseKontaktEdit')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>
            Legt fest, ob das Kontaktfeld einer Adresse auch für übertragene
            Adressen editierbar geschaltet sein soll.
          </p>
          <p>Kunde: Bexity = aktiv, sonst aus</p>
        </div>
        <div className={'config'}>
          <label>Adresse-Einmaladresse nach Übertragung editierbar </label>
          <SliderCheckbox
            value={props.config.isAdresseEinmaladresseEdit ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isAdresseEinmaladresseEdit,
                nameof<ConfigModel>('isAdresseEinmaladresseEdit')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>
            Legt fest, ob das Einmaladressefeld einer Adresse auch für
            übertragene Adressen editierbar geschaltet sein soll.
          </p>
          <p>Kunde: Bexity = aktiv, sonst aus</p>
        </div>
        <div className={'config'}>
          <label>Adresse-Unsichtbarfeld nach Übertragung editierbar </label>
          <SliderCheckbox
            value={props.config.isAdresseUnsichtbarEdit ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isAdresseUnsichtbarEdit,
                nameof<ConfigModel>('isAdresseUnsichtbarEdit')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>
            Legt fest, ob das Unsichtbarfeld einer Adresse auch für übertragene
            Adressen editierbar geschaltet sein soll.
          </p>
          <p>Bei allen Kunden momentan aktiv</p>
        </div>

        <div className={'config'}>
          <label>Adresse-Kontaktdaten am Auftrag halten </label>
          <SliderCheckbox
            value={props.config.saveKontaktdaten ?? false}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.saveKontaktdaten,
                nameof<ConfigModel>('saveKontaktdaten')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>
            Legt fest, ob die Kontaktdaten der Adressen extra am Auftrag
            gehalten werden sollen. So ist sichergestellt, das bei einer
            Änderung dieser Daten die ursprünglich erfassten Daten angezeigt
            werden.
          </p>
          <p>Kunde: Bexity = inaktiv, sonst aktiv</p>
        </div>
        <div className={'config'}>
          <label>Kunde</label>
          <Select
            className='Kunde'
            headerTitle='Kunde'
            name={'Kunde'}
            onChangeHandler={(id?: number) => {
              const clientKunde = CLIENT_KUNDEN.find(k => k.id === id);
              props.setConfigParamField(
                clientKunde?.name == undefined ? 'Nasemann' : clientKunde.name,
                nameof<ConfigModel>('clientKunde')
              );
            }}
            selectedOptionId={
              CLIENT_KUNDEN.find(
                option => option.name == props.config.clientKunde
              )?.id
            }
            selectData={toSelectOptions(CLIENT_KUNDEN, 'name', false, true)}
          />
          {/*tableconfigs.find(option => option.id == tableconfig)?.name,*/}
          <p>
            Dient unter anderem als Tooltip des Übertragungs-Buttons in der
            Auftragsliste: *&quot;An BEXity übertragen&quot; z.B.
            <br />
            Weiterhin wird darurch unterschieden, welcher Betreff bei der
            Registrierungsmail benutzt wird
            <br />
            Bei BEXity wird der Dispohinweis in der Auftragserfassung
            ausgeblendet
            <br />
            Bei MMT wird in der Auftragshistorie die geplante Zustellung
            ausgeblendet
          </p>
        </div>
        <div className={'config'}>
          <label>Auftragserfassung Service (kostenpfl.)</label>
          <Select
            className='Services'
            headerTitle='Services (kostenpfl.)'
            name={'services'}
            onChangeHandler={(id?: number) => {
              const cb = SERVICES.find(c => c.id === id);
              props.setConfigParamField(
                cb?.name == undefined ? 'Nasemann' : cb.name,
                nameof<ConfigModel>('customServices')
              );
            }}
            selectedOptionId={
              SERVICES.find(
                option => option.name == props.config.customServices
              )?.id
            }
            selectData={toSelectOptions(SERVICES, 'name', false, true)}
          />

          <p>
            Jeder Kunde hat eigene Services (kostenpfl. Services) in der
            Auftragserfassung. Die Services spiegeln Spezis im D+ wieder. Jeder
            Service muss eigens programmiert werden. Derzeit sind nur Services
            für Bexity definiert (Lenkeravis, abtragen..)
          </p>
        </div>
        <div className={'config'}>
          <label>Spaltenmodell Auftragsliste/Auftragpos</label>
          <Select
            className='tableconfig'
            headerTitle='Spaltenmodell'
            name={'tableconfig'}
            onChangeHandler={(id?: number) => {
              const tc = TABLE_CONFIGS.find(t => t.id === id);
              props.setConfigParamField(
                tc?.name == undefined ? 'Nasemann' : tc.name,
                nameof<ConfigModel>('auftragsresearchtableconfig')
              );
            }}
            selectedOptionId={
              TABLE_CONFIGS.find(
                option =>
                  option.name == props.config.auftragsresearchtableconfig
              )?.id
            }
            selectData={toSelectOptions(TABLE_CONFIGS, 'name', false, true)}
          />

          <p>
            Welche Tabellenkonfiguration (Darstellung der Tabelle in der
            Auftragsliste,Auftragsposition und in der Gefahrguterfassung) soll
            greifen
          </p>
        </div>
        <div className={'config'}>
          <label>Dokumentenverweise Aktiv</label>
          <SliderCheckbox
            value={props.config.dokumentenverweise ?? true}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.dokumentenverweise,
                nameof<ConfigModel>('dokumentenverweise')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>Kunde: Haalboom, WDS = true sonst false</p>
        </div>
        <div className={'config'}>
          <label>Track&Trace Empfänger Fremdnummer Darstellen</label>
          <SliderCheckbox
            value={props.config.ttEmpfaengerFremdnummer ?? true}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.ttEmpfaengerFremdnummer,
                nameof<ConfigModel>('ttEmpfaengerFremdnummer')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>Kunde: Bexity = false sonst true</p>
        </div>
        <div className={'config'}>
          <label>Track&Trace Empfänger Matchcode Darstellen</label>
          <SliderCheckbox
            value={props.config.ttEmpfaengerMatchcode ?? true}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.ttEmpfaengerMatchcode,
                nameof<ConfigModel>('ttEmpfaengerMatchcode')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>Kunde: Bexity = false sonst true</p>
        </div>
        <div className={'config'}>
          <label>Track&Trace Empfänger Strasse Darstellen</label>
          <SliderCheckbox
            value={props.config.ttEmpfaengerStrasse ?? true}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.ttEmpfaengerStrasse,
                nameof<ConfigModel>('ttEmpfaengerStrasse')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>Kunde: Bexity = false sonst true</p>
        </div>
        <div className={'config'}>
          <label>Track&Trace Inhalt Darstellen</label>
          <SliderCheckbox
            value={props.config.ttInhalt ?? true}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.ttInhalt,
                nameof<ConfigModel>('ttInhalt')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>Kunde: Bexity = false sonst true</p>
        </div>
        <div className={'config'}>
          <label>Track&Trace Versender Fremdnummer Darstellen</label>
          <SliderCheckbox
            value={props.config.ttVersenderFremdnummer ?? true}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.ttVersenderFremdnummer,
                nameof<ConfigModel>('ttVersenderFremdnummer')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>Kunde: Bexity, MMT = false sonst true</p>
        </div>
        <div className={'config'}>
          <label>Track&Trace Versender Matchcode Darstellen</label>
          <SliderCheckbox
            value={props.config.ttVersenderMatchcode ?? true}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.ttVersenderMatchcode,
                nameof<ConfigModel>('ttVersenderMatchcode')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>Kunde: Bexity, MMT = false sonst true</p>
        </div>
        <div className={'config'}>
          <label>Track&Trace Versender Name Darstellen</label>
          <SliderCheckbox
            value={props.config.ttVersenderName ?? true}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.ttVersenderName,
                nameof<ConfigModel>('ttVersenderName')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>Kunde: MMT = false sonst true</p>
        </div>
        <div className={'config'}>
          <label>Track&Trace Versender Ort Darstellen</label>
          <SliderCheckbox
            value={props.config.ttVersenderOrt ?? true}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.ttVersenderOrt,
                nameof<ConfigModel>('ttVersenderOrt')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>Kunde: MMT = false sonst true</p>
        </div>
        <div className={'config'}>
          <label>Track&Trace Versender Strasse Darstellen</label>
          <SliderCheckbox
            value={props.config.ttVersenderStrasse ?? true}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.ttVersenderStrasse,
                nameof<ConfigModel>('ttVersenderStrasse')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>Kunde: Bexity, MMT = false sonst true</p>
        </div>
        <div className={'config'}>
          <label>Track&Trace Versender Block Label</label>
          <input
            value={props.config?.ttVersenderBlockLabel ?? ''}
            onChange={event =>
              props.setConfigParamField(
                event.target.value,
                nameof<ConfigModel>('ttVersenderBlockLabel')
              )
            }
          />
        </div>
        <div className={'config'}>
          <label>Track&Trace Versender Fremdnummer Label</label>
          <input
            value={props.config?.ttVersenderFremdnummerLabel ?? ''}
            onChange={event =>
              props.setConfigParamField(
                event.target.value,
                nameof<ConfigModel>('ttVersenderFremdnummerLabel')
              )
            }
          />
        </div>
        <div className={'config'}>
          <label>Track&Trace Absenderneutral</label>
          <SliderCheckbox
            value={props.config.isTTSwitchAbsenderToNeutral ?? true}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isTTSwitchAbsenderToNeutral,
                nameof<ConfigModel>('isTTSwitchAbsenderToNeutral')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>
            Legt fest, ob der Absender Absender im T&T durch den neutralen
            Absender ersetzt werden soll.
          </p>
          <p>Kunde: Bexity = false sonst true</p>
        </div>

        <div className={'config'}>
          <label>Dokumente nicht löschbar</label>
          <SliderCheckbox
            value={props.config.isDeleteDocumentsForbidden ?? true}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.isDeleteDocumentsForbidden,
                nameof<ConfigModel>('isDeleteDocumentsForbidden')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p>
            Legt fest, ob Dokumente nach der Übertragung noch gelöscht werden
            dürfen
          </p>
          <p>Kunde: MM = true sonst false</p>
        </div>

        <div className={'config'}>
          <label>who is Coco?</label>
          <a
            href={'https://www.chanel.com/de/about-chanel/die-grunderin/'}
            target='_blank'
            rel='noreferrer'
          >
            <img alt='coco' src={process.env.PUBLIC_URL + '/coco.jpg'} />
          </a>
        </div>
        <div className={'config'}>
          <label>Geplantes Zustelldatum ausblenden</label>
          <SliderCheckbox
            value={props.config.zustelldatum_off ?? true}
            onChangeHandler={() => {
              props.setConfigParamField(
                !props.config.zustelldatum_off,
                nameof<ConfigModel>('zustelldatum_off')
              );
            }}
            labelActive={<i className='far fa-eye' />}
            labelInactive={<i className='fas fa-eye-slash' />}
            tooltip={''}
            disabled={false}
          />
          <p></p>
        </div>
      </Fragment>
    );
  };

  return (
    <GridCellWrapper
      classes='coco-wrapper'
      label='CoCo - the comfortable configurator  '
      saveUserAnsicht={() => {
        null;
      }}
    >
      <div className={'coco-buttons'}>
        <Button
          onClickHandler={() => {
            changeConfig(BEXITY, props.setConfigModel);
          }}
        >
          Raben BEXity
        </Button>
        <Button
          onClickHandler={() => {
            changeConfig(MMT, props.setConfigModel);
          }}
        >
          MMT
        </Button>
        <Button
          onClickHandler={() => {
            changeConfig(PHL, props.setConfigModel);
          }}
        >
          PHL
        </Button>
        <Button
          onClickHandler={() => {
            changeConfig(SIEVERS, props.setConfigModel);
          }}
        >
          Sievers
        </Button>
        <Button
          onClickHandler={() => {
            changeConfig(GERSTLAUER, props.setConfigModel);
          }}
        >
          Gerstlauer
        </Button>
        <Button
          onClickHandler={() => {
            changeConfig(HAALBOOM, props.setConfigModel);
          }}
        >
          Haalboom
        </Button>
        <Button
          onClickHandler={() => {
            changeConfig(WDS, props.setConfigModel);
          }}
        >
          WDS-Demo
        </Button>
        <Button onClickHandler={saveAenderungen}>Änderungen Speichern</Button>
      </div>
      <div className={'coco-class'}>{viewConfig()}</div>
    </GridCellWrapper>
  );
};
const mapStateToProps = (state: StateModel) => ({
  config: state.Config,
});

export default connect(mapStateToProps, {
  updateConfigParam,
  setConfigParamField,
  saveConfig,
  setConfigModel,
})(ComfortableConfigurator);
